export const image_ip = 'https://app.zmallapp.com/'
// export const test_ip = 'http://196.189.44.49:7000/'
export const test_ip = 'https://test.zmallapp.com/'


